import React, { useEffect, useRef, useState } from "react";

{
  /*COMMON CODE DD TO BE USED BASED ON FLAG PASSED*/
}
const StandardDropDown = ({
  placeHolder,
  options,
  onChange,
  name,
  className,
  defaultValue,
  languageId,
}) => {
  const [showMenu, setShowMenu] = useState(false);
  const [selectedValue, setSelectedValue] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const inputRef = useRef();
  const [rotate, setRotate] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      //ON CLICK OF BELOW EVENT HIDE THE DD
      if (inputRef.current && !inputRef.current.contains(e.target)) {
        setShowMenu(false);
        setRotate(false);
      }
    };

    window.addEventListener("click", handler);
    return () => {
      window.removeEventListener("click", handler);
    };
  });

  useEffect(() => {
    if (options && !selectedValue && defaultValue) {
      getDefaultOption();
    }
  }, [options]);

  const handleInputClick = (e) => {
    setShowMenu(!showMenu);
    setRotate(!rotate);
  };

  const getDisplay = () => {
    if (!selectedValue || selectedValue.length === 0) {
      const imageSrc = defaultValue && defaultValue.label
      ? `/documents/d/guest/${defaultValue.label}`
      : '';
      return (
        <div className="dropdown-display">

          {defaultValue ? defaultValue.label : placeHolder}
        </div>);
    }

    return (
      <div className="dropdown-display">
        {selectedValue.name ? getLocalizedName(selectedValue) : selectedValue.label}
      </div>
    );
  };

  //ON SLECT OF THE OPTION
  const onItemClick = (option) => {
    let newValue;
    newValue = option;
    setShowMenu(!showMenu);
    setSelectedValue(newValue);
    onChange(newValue);
  };

  const isSelected = (option) => {
    if (!selectedValue) {
      return false;
    }

    return selectedValue.value === option.value;
  };

  //RENDER ALL OPTIONS
  const getOptions = () => {
    if (!searchValue) {
      return options;
    }

    return options.filter(
      (option) =>
        option.label.toLowerCase().indexOf(searchValue.toLowerCase()) >= 0
    );
  };
  //
  const getLocalizedName = (item) => {
    return languageId === "en_US"
      ? item.name_i18n["en-US"]
      : item.name_i18n["ar-SA"];
  };
  const getDefaultOption = () => {
    options.map((option) => {
      if (defaultValue && defaultValue.indexOf(option.value) === 0) {
        setSelectedValue(option);
        onChange(option);
      }
    });
  };
  return (
    <>
      <div className={className} id={`form-select-` + name}>
        <div
          className="dropdown-input"
          id={name}
          ref={inputRef}
          onClick={handleInputClick}
        >
          <div
            className={`dropdown-select-value ${
              !selectedValue && "dropdown-placeholder"
            }`}
          >
            {getDisplay()}
          </div>
          <div className="dropdown-tools">
            <div className="dropdown-tool">
              <svg
                width="12"
                height="8"
                viewBox="0 0 12 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{
                  transform: rotate ? "rotate(180deg)" : "rotate(0deg)",
                }}
              >
                <path
                  d="M1 1.5L6 6.5L11 1.5"
                  stroke="#002F70"
                  stroke-width="1.66667"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
        </div>
        {showMenu && (
          <div className="dropdown-container">
            <div className="dropdown-of-menu-flag">
              {getOptions().map((option, index) => (
                <div
                  id={index}
                  onClick={() => onItemClick(option)}
                  key={option.value}
                  className={`dropdown-item ${
                    isSelected(option) && "selected"
                  }`}
                >

                  {option.label}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default StandardDropDown;
